module.exports = __webpack_public_path__ + "img/would you like one.b0d131ff.png";